import React, { useState, useRef, useMemo } from 'react';
import SignatureCanvas from 'react-signature-canvas';

// ============================================================================
// 1. DATA DE LOS 3 FORMATOS
// ============================================================================
const TAREAS_APERTURA = [
  { id: 1, hora: "6:45 a. m.", actividad: "Reportar mediante foto al grupo de whapsapp, la apertura del supermercado" },
  { id: 2, hora: "6:48 a. m.", actividad: "Examina estado de Neveras, Rack y UPS reportando al director de operaciones en caso de alguna novedad" },
  { id: 3, hora: "6:50 a. m.", actividad: "Confirmar con el encargado de plagas o aux de PGC, capturas o atrapamientos en bodega y piso de venta" },
  { id: 4, hora: "6:52 a. m.", actividad: "Verificar que el personal programado para apertura llegue a su turno y hayan entregado todos el celular" },
  { id: 5, hora: "6:55 a. m.", actividad: "Revisa limpieza y seguridad de áreas exteriores, puertas, parqueaderos, áreas contiguas al supermercado" },
  { id: 6, hora: "6:55 a. m.", actividad: "Realiza la verificación del inventario cíclico del día /noche anterior para su respectivo análisis y correctivos a tomar." },
  { id: 7, hora: "7:00 a. m.", actividad: "Define plan de trabajo junto con el coordinador de area, dando prioridad al Fruver garantizando producto porcionado, saneo y alistamiento" },
  { id: 8, hora: "7:00 a. m.", actividad: "Dirigir y coordinar el surtido de fruver junto con el coordinador de area" },
  { id: 9, hora: "9:00 a. m.", actividad: "Revisa, aseo y orden en el área de proceso de porcionados y BODEGA de Fruver" },
  { id: 10, hora: "9:30 a. m.", actividad: "Enviar evidencia fotografica del surtido de fruver al grupo ADM" },
  { id: 11, hora: "9:30 a. m.", actividad: "Revisa y garantiza el ajuste o retiro de precios vencidos en las secciones de Industria, Fruver y Licores" },
  { id: 12, hora: "9:50 a. m.", actividad: "Realiza seguimiento y reporta diferencias de Fruver a centro de acopio para su respectiva corrección" },
  { id: 13, hora: "10:00 a. m.", actividad: "Inspeccionar la bodega de PGC garantizando orden, limpieza y la rotacion de los productos almacenados" },
  { id: 14, hora: "10:30 a. m.", actividad: "Verificar que las averías y bajas sean realizadas a diario coordinando con los Lideres" },
  { id: 15, hora: "11:00 a. m.", actividad: "Recorrer el Fruver y los pasillos de Industria, verificando que se encuentren con niveles de surtido óptimo" },
  { id: 16, hora: "11:30 a. m.", actividad: "Haga seguimiento a los productos con saldos o margen negativo (inconsistencias de inventario)" }
];

const TAREAS_PERMANENTES = [
  { id: 1, hora: "Turno", actividad: "Verificar la disponibilidad de cajeros en sus respectivos puntos de pago para evitar las filas" },
  { id: 2, hora: "Turno", actividad: "Revisar periódicamente los grupos de WhatsApp y dar solución o respuesta a los pendientes" },
  { id: 3, hora: "Turno", actividad: "Realice prueba a la planta electrica (JUEVES), enviar video y reporte al director de operaciones" },
  { id: 4, hora: "Turno", actividad: "Reporte al director de operaciones, novedades urgentes con el personal a cargo" },
  { id: 5, hora: "Turno", actividad: "Realizar monitoreo al abastecimiento e inventarios de Pgc" },
  { id: 6, hora: "Turno", actividad: "Inspeccionar que los productos de oferta en separata se encuentren exhibidos y destacados" },
  { id: 7, hora: "Turno", actividad: "Garantizar el cumplimiento del rutero para mercaderistas e impulsadores, y uso de planilla" },
  { id: 8, hora: "Turno", actividad: "Garantice disponibilidad de iluminación en piso de ventas y ahorro de energía cuando no sea necesario" },
  { id: 9, hora: "Turno", actividad: "Hacer seguimiento a la temperatura de neveras y congelados, garantice registros en formato de rrhh" },
  { id: 10, hora: "Turno", actividad: "Confirmar existencia de material de empaque, bolsas pre corte en Fruver, plástica y reutilizables en cajas" },
  { id: 11, hora: "Turno", actividad: "Participar en el recibo de mercancía, y realizar auditoría aleatoria a diferentes proveedores" },
  { id: 12, hora: "Turno", actividad: "Examinar áreas de recibo y almacenamiento Bodega Fruver e Industria (orden, aseo, procedimientos)" },
  { id: 13, hora: "Turno", actividad: "Controlar y administrar el material POP del supermercado" },
  { id: 14, hora: "Turno", actividad: "Practicar seguimiento a espacios adicionales arrendados por proveedores (uso y vigencias)" },
  { id: 15, hora: "Turno", actividad: "Garantizar que todos los productos del lineal se encuentren correctamente rotulados con precio correcto" },
  { id: 16, hora: "Turno", actividad: "Reporte de productos agotados o proximos al equipo de Compras" },
  { id: 17, hora: "Turno", actividad: "Garantizar verificadores de precio funcionando y realizar muestras aleatorias" },
  { id: 18, hora: "Turno", actividad: "Verificar plan de trabajo para el ciclico de PGC y granja según el cronograma" },
  { id: 19, hora: "Turno", actividad: "Realizar control a la granja verificando atencion, surtido y limpieza" },
  { id: 20, hora: "Turno", actividad: "Revise que el personal tenga sus pertenencias en casillero, sin celulares ni billeteras en área de trabajo" },
  { id: 21, hora: "Turno", actividad: "Revise que los pisos permanezcan secos, limpios y sin emplazamiento de agua" },
  { id: 22, hora: "Turno", actividad: "Verifique que el personal porte la dotación limpia (botas, Jeans, buso, cabello recogido/malla)" }
];

const TAREAS_CIERRE = [
  { id: 1, hora: "3:30 p. m.", actividad: "Realizar en compañía del subadministrador el sugerido de fruver" },
  { id: 2, hora: "7:30 p. m.", actividad: "Confirmar todos los traslados que se realizan entre supermercados y Cedi" },
  { id: 3, hora: "7:40 p. m.", actividad: "Realizar recorrido por los pasillos de PGC identificando novedades de surtido y asignando tareas" },
  { id: 4, hora: "9:00 p. m.", actividad: "Confirmar todos los cierres finales en cajas, garantizando documentos de faltantes/sobrantes y devoluciones" },
  { id: 5, hora: "9:10 p. m.", actividad: "Asegure que las áreas de procesos; porcionados y mermas queden ordenados, aseados y limpios" },
  { id: 6, hora: "9:20 p. m.", actividad: "Enviar los videos del área de PCG debidamente surtido y Fruver al grupo de WhatsApp" },
  { id: 7, hora: "9:25 p. m.", actividad: "Verificar que todas las luces queden apagadas" },
  { id: 8, hora: "9:25 p. m.", actividad: "Ratifiqué que las neveras de gaseosas y cervezas estén apagadas (no aplica para congelados)" },
  { id: 9, hora: "9:26 p. m.", actividad: "Inspección mediante el CCTV del exterior de las instalaciones, confirmando normalidad" },
  { id: 10, hora: "9:28 p. m.", actividad: "Verificar que todo el personal de cierre haya salido y finalice turno en el huellero" },
  { id: 11, hora: "9:28 p. m.", actividad: "Verificar el correcto cierre de las puertas y rejas con su respectivo candado" },
  { id: 12, hora: "9:30 p. m.", actividad: "Reportar cierre por el grupo administrativo" },
  { id: 13, hora: "9:30 p. m.", actividad: "Confirmar armado de alarma con central de seguridad" }
];

// Función para calcular el cumplimiento real leyendo el JSON
const calcularCumplimientoReal = (registro) => {
  if (!registro || !registro.respuestas) return 0;
  try {
    const resObj = typeof registro.respuestas === 'string' ? JSON.parse(registro.respuestas) : registro.respuestas;
    const tareasOriginales = registro.tipo_checklist === 'APERTURA' ? TAREAS_APERTURA : registro.tipo_checklist === 'PERMANENTES' ? TAREAS_PERMANENTES : TAREAS_CIERRE;
    const tareasCumplidas = tareasOriginales.filter(t => resObj[t.id]?.cumple === "SI").length;
    return Math.round((tareasCumplidas / tareasOriginales.length) * 100) || 0;
  } catch (e) {
    return registro.porcentaje_cumplimiento || 0;
  }
};

export default function SupervisionPOS({ usuario, onBackToMenu }) {
  const [vistaActual, setVistaActual] = useState("menu");
  const [historialRegistros, setHistorialRegistros] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  
  const [registroSeleccionado, setRegistroSeleccionado] = useState(null);

  // ============================================================================
  // LÓGICA ABAC
  // ============================================================================
  const permisosABAC = useMemo(() => {
    try {
      const parsed = typeof usuario?.permisos_avanzados === 'string' 
        ? JSON.parse(usuario.permisos_avanzados) 
        : (usuario?.permisos_avanzados || {});
      return parsed.micros || parsed; 
    } catch (e) { 
      return {}; 
    }
  }, [usuario]);

  const cargoUpper = String(usuario?.cargo || "").toUpperCase().trim();
  const esAdminGlobal = cargoUpper.includes("SUPER_ADMIN");

  const checkPermiso = (nombreSubmodulo) => {
    if (esAdminGlobal) return true;
    return permisosABAC[nombreSubmodulo] !== undefined;
  };

  const verApertura = checkPermiso('Checklist Apertura');
  const verPermanentes = checkPermiso('Actividades Permanentes');
  const verCierre = checkPermiso('Checklist Cierre');
  const verHistorial = checkPermiso('Historial POS');

  const sinPermisosPos = !verApertura && !verPermanentes && !verCierre && !verHistorial;

  // ============================================================================
  // COMPONENTE DINÁMICO: FORMULARIO CHECKLIST CON FIRMA
  // ============================================================================
  const FormularioChecklist = ({ titulo, subtitulo, icono, tareas, tipo }) => {
    const [respuestas, setRespuestas] = useState({});
    const [enviando, setEnviando] = useState(false);
    const [alerta, setAlerta] = useState(null);
    const sigCanvas = useRef(null);

    const handleToggle = (idTarea, valor) => {
      setRespuestas(prev => ({ ...prev, [idTarea]: { ...prev[idTarea], cumple: valor } }));
    };

    const handleObservacion = (idTarea, texto) => {
      setRespuestas(prev => ({ ...prev, [idTarea]: { ...prev[idTarea], observacion: texto } }));
    };

    const tareasRespondidas = tareas.filter(tarea => respuestas[tarea.id]?.cumple).length;
    const porcentajeAvance = Math.round((tareasRespondidas / tareas.length) * 100) || 0;

    const tareasCumplidas = tareas.filter(tarea => respuestas[tarea.id]?.cumple === "SI").length;
    const porcentajeCumplimientoReal = Math.round((tareasCumplidas / tareas.length) * 100) || 0;

    const handleGuardar = async (e) => {
      e.preventDefault();
      if (porcentajeAvance < 100) return;

      if (sigCanvas.current && sigCanvas.current.isEmpty()) {
        setAlerta({ tipo: "error", texto: "Debes firmar el reporte antes de enviarlo." });
        return;
      }
      
      setEnviando(true);
      try {
        const firmaBase64 = sigCanvas.current.getCanvas().toDataURL("image/png");

        const payload = {
          tipo_checklist: tipo,
          documento_usuario: usuario?.documento || usuario?.cedula,
          nombre_responsable: `${usuario?.nombres} ${usuario?.apellidos}`,
          sede: usuario?.centroTrabajo || "Sede Principal",
          porcentaje_cumplimiento: porcentajeCumplimientoReal,
          firma_base64: firmaBase64,
          respuestas: respuestas
        };

        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/supervision-pos`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
        });
        const data = await res.json();

        if (data.success) {
          setAlerta({ tipo: "success", texto: `¡Checklist firmado y guardado con éxito!` });
          setTimeout(() => { setVistaActual("menu"); }, 2500);
        } else {
          setAlerta({ tipo: "error", texto: data.message || "Error al guardar el checklist." });
        }
      } catch (error) {
        setAlerta({ tipo: "error", texto: "Error de conexión con el servidor backend." });
      } finally {
        setEnviando(false);
      }
    };

    return (
      <div className="w-full animate-fade-in">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4 border-b border-slate-200/50 pb-6 sticky top-0 bg-white/70 backdrop-blur-xl z-20 p-4 sm:-mx-8 sm:px-8 rounded-b-[24px] shadow-sm">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-3xl shadow-inner icon-bounce">{icono}</div>
            <div>
              <h2 className="text-2xl font-black text-slate-800 tracking-tight">{titulo}</h2>
              <p className="text-xs font-bold text-slate-500 mt-1 uppercase tracking-widest">{subtitulo}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 w-full md:w-auto">
            
            <div className="flex flex-col items-end mr-4 border-r border-slate-200 pr-4">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Cumplimiento</span>
              <span className={`text-lg font-black ${porcentajeCumplimientoReal >= 80 ? 'text-emerald-600' : porcentajeCumplimientoReal >= 50 ? 'text-amber-500' : 'text-rose-600'}`}>{porcentajeCumplimientoReal}%</span>
            </div>

            <div className="flex flex-col items-end">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Llenado</span>
              <span className={`text-lg font-black ${porcentajeAvance === 100 ? 'text-blue-600' : 'text-slate-600'}`}>{porcentajeAvance}%</span>
            </div>

            <button onClick={() => setVistaActual("menu")} className="ml-2 px-5 py-2.5 rounded-xl bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 text-xs font-bold shadow-sm transition-all cursor-pointer">Volver</button>
          </div>
        </div>

        {alerta && (
          <div className={`mb-6 p-4 rounded-2xl text-xs font-black border animate-fade-in-down ${alerta.tipo === "success" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200"}`}>
            {alerta.texto}
          </div>
        )}

        <div className="bg-white/60 backdrop-blur-xl p-6 rounded-[28px] border border-white shadow-sm mb-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Sede</p><p className="text-sm font-bold text-slate-800 mt-1">{usuario?.centroTrabajo || "Sede Principal"}</p></div>
          <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Fecha</p><p className="text-sm font-bold text-slate-800 mt-1">{new Date().toLocaleDateString()}</p></div>
          <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Responsable</p><p className="text-sm font-bold text-slate-800 mt-1 uppercase">{usuario?.nombres} {usuario?.apellidos}</p></div>
        </div>

        <form onSubmit={handleGuardar}>
          <div className="bg-white/70 backdrop-blur-xl rounded-[32px] border border-white shadow-sm overflow-hidden mb-6">
            <div className="overflow-x-auto custom-scrollbar">
              <table className="w-full text-left min-w-[800px]">
                <thead className="bg-slate-50/80 border-b border-slate-200">
                  <tr>
                    <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[10%]">Hora/Turno</th>
                    <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[50%]">Actividad a Verificar</th>
                    <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[20%] text-center">Cumple</th>
                    <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[20%]">Observación (Opcional)</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {tareas.map((tarea) => {
                    const res = respuestas[tarea.id] || {};
                    return (
                      <tr key={tarea.id} className="hover:bg-white/50 transition-colors group">
                        <td className="py-4 px-6 align-top">
                          <span className="inline-block bg-blue-50 text-blue-700 text-[10px] font-black px-2.5 py-1 rounded-lg border border-blue-100 whitespace-nowrap shadow-sm group-hover:scale-105 transition-transform">{tarea.hora}</span>
                        </td>
                        <td className="py-4 px-6 align-top"><p className="text-xs font-bold text-slate-700 leading-relaxed">{tarea.actividad}</p></td>
                        <td className="py-4 px-6 align-top text-center">
                          <div className="flex items-center justify-center gap-2">
                            <button type="button" onClick={() => handleToggle(tarea.id, "SI")} className={`px-4 py-2 rounded-xl text-[10px] font-black transition-all cursor-pointer ${res.cumple === "SI" ? "bg-emerald-500 text-white shadow-md shadow-emerald-500/30 scale-105" : "bg-slate-100 text-slate-500 hover:bg-slate-200"}`}>SÍ</button>
                            <button type="button" onClick={() => handleToggle(tarea.id, "NO")} className={`px-4 py-2 rounded-xl text-[10px] font-black transition-all cursor-pointer ${res.cumple === "NO" ? "bg-rose-500 text-white shadow-md shadow-rose-500/30 scale-105" : "bg-slate-100 text-slate-500 hover:bg-slate-200"}`}>NO</button>
                          </div>
                        </td>
                        <td className="py-4 px-6 align-top">
                          <textarea rows="2" placeholder="Novedad..." value={res.observacion || ""} onChange={(e) => handleObservacion(tarea.id, e.target.value)} className="w-full bg-white/60 border border-slate-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white resize-none shadow-inner transition-all custom-scrollbar"></textarea>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white/60 backdrop-blur-xl p-6 rounded-[32px] border border-white shadow-sm mt-6 mb-8 flex flex-col md:flex-row gap-6 items-center">
            <div className="flex-1 w-full">
              <h3 className="text-sm font-black text-slate-800 uppercase tracking-widest mb-2">Firma Digital Requerida</h3>
              <p className="text-xs text-slate-500 font-bold mb-4 leading-relaxed">Confirmo que he verificado personalmente los puntos anteriores en la sede <strong className="text-slate-700">{usuario?.centroTrabajo || "Principal"}</strong>.</p>
              <div className="border-2 border-dashed border-blue-200 rounded-[24px] bg-white overflow-hidden relative shadow-inner">
                <SignatureCanvas ref={sigCanvas} penColor="#1e293b" canvasProps={{ className: "w-full h-40 sm:h-48 cursor-crosshair touch-none" }} />
                <button type="button" onClick={() => sigCanvas.current.clear()} className="absolute top-4 right-4 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-[10px] font-black transition cursor-pointer shadow-sm">Limpiar Firma</button>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <button type="submit" disabled={enviando || porcentajeAvance < 100} className={`btn-glow px-10 py-5 rounded-2xl text-xs font-black uppercase tracking-widest text-white transition-all shadow-lg ${enviando || porcentajeAvance < 100 ? "bg-slate-300 text-slate-500 shadow-none cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 cursor-pointer shadow-blue-500/30 hover:-translate-y-0.5"}`}>
              {enviando ? "Guardando Reporte..." : porcentajeAvance < 100 ? "Faltan Tareas por Marcar" : "Firmar y Guardar Reporte"}
            </button>
          </div>
        </form>
      </div>
    );
  };

  // ============================================================================
  // COMPONENTE: CARGAR HISTORIAL 
  // ============================================================================
  const cargarHistorial = async () => {
    setCargandoHistorial(true);
    setVistaActual("historial");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/supervision-pos/historial`);
      const data = await res.json();
      if(data.success) setHistorialRegistros(data.registros);
    } catch(err) {
      console.error(err);
    } finally {
      setCargandoHistorial(false);
    }
  };

  // ============================================================================
  // RENDER PRINCIPAL Y ROUTER
  // ============================================================================
  return (
    <div className="w-full min-h-screen py-6 px-4 flex flex-col items-center relative z-10">
      <div className="bg-white/40 backdrop-blur-[45px] rounded-[36px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-6 sm:p-10 max-w-7xl w-full mx-auto border border-white/80 animate-fade-in relative h-[90vh] overflow-y-auto custom-scrollbar">
        
        {vistaActual === "menu" && (
          <div className="animate-fade-in">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-slate-200/50 pb-6 mb-8 gap-4 animate-fade-in-down">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-3xl shadow-sm icon-bounce">🛒</div>
                <div>
                  <h1 className="text-2xl sm:text-3xl font-black text-slate-800 tracking-tight">Punto de Venta POS</h1>
                  <p className="text-xs sm:text-sm font-bold text-slate-500 mt-1">Supervisión y listas de chequeo administrativas.</p>
                </div>
              </div>
              <button onClick={onBackToMenu} className="px-6 py-3 rounded-2xl bg-white hover:bg-slate-50 text-slate-700 text-xs font-black uppercase tracking-widest transition-all shadow-sm border border-slate-200 cursor-pointer">Volver al Sistema</button>
            </div>

            {sinPermisosPos ? (
              <div className="p-12 text-center bg-white/60 backdrop-blur-xl border border-white/80 rounded-[32px] shadow-xl animate-fade-in-up delay-100">
                <span className="text-6xl block mb-6 drop-shadow-md">🛡</span>
                <h3 className="text-2xl font-black text-slate-800">Módulo Bloqueado</h3>
                <p className="text-sm text-slate-500 font-bold mt-2">No tienes formularios de POS asignados en tu matriz de privilegios ABAC.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {verApertura && (
                  <div onClick={() => setVistaActual("apertura")} className="bg-white/70 hover:bg-white/90 backdrop-blur-xl rounded-[28px] p-6 border border-white shadow-lg hover:shadow-xl transition-all cursor-pointer group flex flex-col items-start card-hover glass-reflection animate-fade-in-up delay-100">
                    <div className="w-14 h-14 bg-amber-50/80 rounded-2xl flex items-center justify-center text-3xl border border-amber-100 mb-5 shadow-inner icon-bounce">🌅</div>
                    <h3 className="text-lg font-black text-slate-800 mb-2 leading-tight">Checklist de Apertura</h3>
                    <p className="text-xs text-slate-500 font-bold">Verificación AM (Rack, Personal, Fruver).</p>
                  </div>
                )}
                {verPermanentes && (
                  <div onClick={() => setVistaActual("permanentes")} className="bg-white/70 hover:bg-white/90 backdrop-blur-xl rounded-[28px] p-6 border border-white shadow-lg hover:shadow-xl transition-all cursor-pointer group flex flex-col items-start card-hover glass-reflection animate-fade-in-up delay-200">
                    <div className="w-14 h-14 bg-blue-50/80 rounded-2xl flex items-center justify-center text-3xl border border-blue-100 mb-5 shadow-inner icon-bounce">🔄</div>
                    <h3 className="text-lg font-black text-slate-800 mb-2 leading-tight">Act. Permanentes</h3>
                    <p className="text-xs text-slate-500 font-bold">Monitoreo de cajas, averías y surtido continuo.</p>
                  </div>
                )}
                {verCierre && (
                  <div onClick={() => setVistaActual("cierre")} className="bg-white/70 hover:bg-white/90 backdrop-blur-xl rounded-[28px] p-6 border border-white shadow-lg hover:shadow-xl transition-all cursor-pointer group flex flex-col items-start card-hover glass-reflection animate-fade-in-up delay-300">
                    <div className="w-14 h-14 bg-indigo-50/80 rounded-2xl flex items-center justify-center text-3xl border border-indigo-100 mb-5 shadow-inner icon-bounce">🌃</div>
                    <h3 className="text-lg font-black text-slate-800 mb-2 leading-tight">Checklist de Cierre</h3>
                    <p className="text-xs text-slate-500 font-bold">Validación PM (Cajas, Luces, Seguridad).</p>
                  </div>
                )}
                {verHistorial && (
                  <div onClick={cargarHistorial} className="bg-white/70 hover:bg-white/90 backdrop-blur-xl rounded-[28px] p-6 border border-white shadow-lg hover:shadow-xl transition-all cursor-pointer group flex flex-col items-start card-hover glass-reflection animate-fade-in-up delay-400">
                    <div className="w-14 h-14 bg-emerald-50/80 rounded-2xl flex items-center justify-center text-3xl border border-emerald-100 mb-5 shadow-inner icon-bounce">🗂️</div>
                    <h3 className="text-lg font-black text-slate-800 mb-2 leading-tight">Historial y Reportes</h3>
                    <p className="text-xs text-slate-500 font-bold">Auditoría de todos los checklists enviados.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* VISTAS DE FORMULARIOS */}
        {vistaActual === "apertura" && verApertura && <FormularioChecklist tipo="APERTURA" titulo="Checklist de Apertura" subtitulo="Supervisión Diaria POS (6:45 AM - 11:30 AM)" icono="🌅" tareas={TAREAS_APERTURA} />}
        {vistaActual === "permanentes" && verPermanentes && <FormularioChecklist tipo="PERMANENTES" titulo="Actividades Permanentes" subtitulo="Supervisión Continua Inherente al Cargo" icono="🔄" tareas={TAREAS_PERMANENTES} />}
        {vistaActual === "cierre" && verCierre && <FormularioChecklist tipo="CIERRE" titulo="Checklist de Cierre" subtitulo="Supervisión Diaria POS (3:30 PM - 9:30 PM)" icono="🌃" tareas={TAREAS_CIERRE} />}
        
        {/* VISTA DEL HISTORIAL Y DETALLES */}
        {vistaActual === "historial" && verHistorial && (
          <div className="animate-fade-in">
             <div className="flex justify-between items-center mb-6 border-b border-slate-200/50 pb-6">
                <div>
                  <h2 className="text-2xl font-black text-slate-800 tracking-tight">{registroSeleccionado ? `Detalle de Reporte #${registroSeleccionado.id}` : "Historial de Auditorías"}</h2>
                  <p className="text-xs font-bold text-slate-500 mt-1 uppercase tracking-widest">{registroSeleccionado ? "Respuestas y Observaciones" : "Registros de Supervisión POS"}</p>
                </div>
                <button onClick={() => { if(registroSeleccionado) { setRegistroSeleccionado(null); } else { setVistaActual("menu"); } }} className="px-5 py-2.5 rounded-xl bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 text-xs font-bold shadow-sm transition-all cursor-pointer">
                  {registroSeleccionado ? "Volver a la Lista" : "Volver al Menú"}
                </button>
             </div>
             
             {cargandoHistorial ? (
               <div className="text-center py-20 text-slate-500 font-bold animate-pulse-soft">Cargando registros...</div>
             ) : registroSeleccionado ? (
               
               /* ==================== VISTA DE DETALLE ==================== */
               <div className="animate-fade-in-up">
                  <div className="bg-white/70 backdrop-blur-xl p-6 rounded-[28px] border border-white shadow-sm mb-6 grid grid-cols-2 sm:grid-cols-4 gap-6">
                    <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Sede</p><p className="text-sm font-bold text-slate-800 mt-1">{registroSeleccionado.sede}</p></div>
                    <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Fecha y Hora</p><p className="text-sm font-bold text-slate-800 mt-1">{new Date(registroSeleccionado.fecha).toLocaleDateString()} {registroSeleccionado.hora_envio}</p></div>
                    <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Responsable</p><p className="text-sm font-bold text-slate-800 mt-1 uppercase">{registroSeleccionado.nombre_responsable}</p></div>
                    
                    {/* SE MUESTRA EL PORCENTAJE RECALCULADO EN EL DETALLE */}
                    {(() => {
                      const cumplimientoReal = calcularCumplimientoReal(registroSeleccionado);
                      const colorCumplimiento = cumplimientoReal >= 80 ? 'text-emerald-600' : cumplimientoReal >= 50 ? 'text-amber-500' : 'text-rose-600';
                      return (
                        <div><p className="text-[10px] uppercase font-black text-slate-400 tracking-widest">Cumplimiento</p><p className={`text-xl font-black mt-1 ${colorCumplimiento}`}>{cumplimientoReal}%</p></div>
                      );
                    })()}
                  </div>

                  <div className="bg-white/70 backdrop-blur-xl rounded-[32px] border border-white shadow-sm overflow-hidden mb-6">
                    <div className="overflow-x-auto custom-scrollbar">
                      <table className="w-full text-left">
                        <thead className="bg-slate-50/80 border-b border-slate-200">
                          <tr>
                            <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[50%]">Actividad Evaluada</th>
                            <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[15%] text-center">Cumplimiento</th>
                            <th className="py-4 px-6 text-[10px] font-black uppercase tracking-widest text-slate-500 w-[35%]">Observación (Novedad)</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                          {(() => {
                            const resObj = typeof registroSeleccionado.respuestas === 'string' ? JSON.parse(registroSeleccionado.respuestas) : registroSeleccionado.respuestas;
                            const tareasOriginales = registroSeleccionado.tipo_checklist === 'APERTURA' ? TAREAS_APERTURA : registroSeleccionado.tipo_checklist === 'PERMANENTES' ? TAREAS_PERMANENTES : TAREAS_CIERRE;
                            
                            return tareasOriginales.map((tarea) => {
                              const r = resObj[tarea.id] || { cumple: 'N/A', observacion: '' };
                              return (
                                <tr key={tarea.id} className="hover:bg-white/50">
                                  <td className="py-4 px-6"><p className="text-xs font-bold text-slate-700">{tarea.actividad}</p></td>
                                  <td className="py-4 px-6 text-center">
                                    <span className={`inline-block px-3 py-1 rounded-lg text-[10px] font-black ${r.cumple === 'SI' ? 'bg-emerald-100 text-emerald-700' : r.cumple === 'NO' ? 'bg-rose-100 text-rose-700' : 'bg-slate-100 text-slate-500'}`}>{r.cumple || 'N/A'}</span>
                                  </td>
                                  <td className="py-4 px-6">
                                    {r.observacion ? <p className="text-xs text-red-700 bg-red-50 p-2 rounded-xl font-bold border border-red-100 inline-block">{r.observacion}</p> : <span className="text-[10px] text-slate-400 italic">Sin novedades</span>}
                                  </td>
                                </tr>
                              );
                            });
                          })()}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="bg-white/60 p-6 rounded-[32px] border border-white shadow-sm text-center">
                    <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4">Firma del Responsable de Sede</h3>
                    {registroSeleccionado.firma_base64 ? (
                      <img src={registroSeleccionado.firma_base64} alt="Firma Digital" className="h-28 mx-auto object-contain mix-blend-multiply border-b-2 border-slate-300 pb-2 mb-2" />
                    ) : (
                      <p className="text-sm font-mono text-slate-400 italic h-20 flex items-center justify-center">Sin firma registrada</p>
                    )}
                    <p className="text-xs font-black text-slate-800 uppercase tracking-widest">{registroSeleccionado.nombre_responsable}</p>
                  </div>
               </div>

             ) : (
               /* ==================== VISTA DE TABLA ==================== */
               <div className="bg-white/70 backdrop-blur-xl border border-white rounded-[32px] overflow-hidden shadow-sm">
                  <table className="w-full text-left text-sm">
                    <thead className="bg-slate-50 border-b border-slate-200">
                      <tr>
                        <th className="py-4 px-6 text-[10px] font-black uppercase text-slate-500">ID / Fecha</th>
                        <th className="py-4 px-6 text-[10px] font-black uppercase text-slate-500">Tipo de Lista</th>
                        <th className="py-4 px-6 text-[10px] font-black uppercase text-slate-500 text-center">Cumplimiento</th>
                        <th className="py-4 px-6 text-[10px] font-black uppercase text-slate-500 text-center">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 font-bold text-slate-700">
                      {historialRegistros.length > 0 ? historialRegistros.map((reg) => {
                        // SE MUESTRA EL PORCENTAJE RECALCULADO EN LA TABLA
                        const cumplimientoReal = calcularCumplimientoReal(reg);
                        const colorCumplimiento = cumplimientoReal >= 80 ? 'text-emerald-600' : cumplimientoReal >= 50 ? 'text-amber-500' : 'text-rose-600';
                        
                        return (
                          <tr key={reg.id} className="hover:bg-white/50 transition-colors">
                            <td className="py-4 px-6"><span className="block text-slate-900">#{reg.id}</span><span className="text-[10px] text-slate-500">{new Date(reg.fecha).toLocaleDateString()} - {reg.hora_envio}</span></td>
                            <td className="py-4 px-6"><span className={`px-2.5 py-1 rounded-lg text-[10px] uppercase tracking-widest ${reg.tipo_checklist === 'APERTURA' ? 'bg-amber-100 text-amber-700' : reg.tipo_checklist === 'CIERRE' ? 'bg-indigo-100 text-indigo-700' : 'bg-blue-100 text-blue-700'}`}>{reg.tipo_checklist}</span></td>
                            <td className="py-4 px-6 text-center"><span className={`${colorCumplimiento} font-black`}>{cumplimientoReal}%</span></td>
                            <td className="py-4 px-6 text-center">
                              <button onClick={() => setRegistroSeleccionado(reg)} className="px-4 py-2.5 bg-blue-50 hover:bg-blue-600 text-blue-700 hover:text-white rounded-xl text-[10px] font-black transition-colors cursor-pointer border border-blue-100 shadow-sm">
                                Ver Detalles
                              </button>
                            </td>
                          </tr>
                        );
                      }) : <tr><td colSpan={4} className="text-center py-10 text-slate-500">No hay auditorías registradas.</td></tr>}
                    </tbody>
                  </table>
               </div>
             )}
          </div>
        )}

      </div>
    </div>
  );
}